const formatDate = (date) => {
  if (!date) return '------';
  const rawDate = new Date(date).toString().split('(')[0];
  return rawDate.substring(3, rawDate.length - 13);
};

export default formatDate;
